import { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmModal } from '@microservices/wiskey-react-components'
import { DataGrid, GridCellParams, GridColDef } from '@microservices/wiskey-react-table-component'
import { Grid } from '@mui/material'

import {
  generateDataGridActionsColumnForStyleSettings,
  generateDataGridPreviewColumnsForStyleSettings,
} from '@pages/ConfigStyleSettings/helpers'

import { FLEXIBLE } from '@constants'

type TableWithActionsProps = {
  columns: GridColDef<any>[]
  rows: readonly any[]
  onDelete?: (id: number) => void
  onEdit?: (id: number) => void
  loading?: boolean
}

export const TableWithActions: FC<TableWithActionsProps> = ({
  columns,
  rows,
  onDelete,
  onEdit,
  loading,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [currentRowId, setCurrentRowId] = useState<number>()
  const { t } = useTranslation()

  const handleEdit = (params: GridCellParams<any, any>) => {
    onEdit?.(params.row.id)
  }

  const handleClickDelete = (params: GridCellParams<any, any>) => {
    if (params.row.id) {
      setShowDeleteModal(true)
      setCurrentRowId(params.row.id)
    }
  }

  const handleDelete = () => {
    if (currentRowId) {
      onDelete?.(currentRowId)
      setShowDeleteModal(false)
    }
  }

  const handleClose = () => setShowDeleteModal(false)

  const columnsWithActions = useMemo(
    () => [
      ...columns,
      ...generateDataGridPreviewColumnsForStyleSettings(),
      generateDataGridActionsColumnForStyleSettings({
        onEdit: onEdit ? handleEdit : undefined,
        onDelete: onDelete ? handleClickDelete : undefined,
      }),
    ],
    [columns]
  )

  return (
    <Grid container sx={{ ...FLEXIBLE, px: 1 }}>
      {showDeleteModal && (
        <ConfirmModal
          actionBtnText={t('modal.delete.btn')}
          isShow={showDeleteModal}
          text={t('modal.delete.warning')}
          title={t('modal.delete.title')}
          containerStyle={{
            px: 0.5,
            py: 0.5,
            // borderRadius: 0
          }}
          onClose={handleClose}
          onConfirm={handleDelete}
        />
      )}
      <Grid container item sx={FLEXIBLE}>
        <DataGrid
          hideFooter
          columns={columnsWithActions}
          loading={loading}
          rows={rows}
          sx={{ borderRadius: 0 }}
        />
      </Grid>
    </Grid>
  )
}
